import { SortByValues } from "api/links";

import { ILink } from "/@types";

export const linkPropertyToSortBy: Partial<Record<keyof ILink, SortByValues>> =
  {
    url: "longUrl",
    owner: "owner",
    createdAt: "date",
    views: "views",
    shortUrl: "shortUrl",
  };
